module.exports = __webpack_public_path__ + "img/ecv_naked.188b3217.svg";